import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaLock, FaSignOutAlt, FaUser } from "react-icons/fa";
import logo from "../../assets/images/LOGO.png";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, fetchUserRole } from "../../redux/userSlice";
import Modal from "../Modal/Modal";
import { currencyOption } from "../../utility/data";
import { userProfileUpdate } from "../../services/userProfile/updateProfile";
import { Toast } from 'primereact/toast';

const ProfileDropdownMenu = ({ isOpen, onProfileClick, onLogout, role, navigate }) => {
  if (!isOpen) return null;

  return (
    <ul className="absolute right-0 z-10 text-xs w-[9rem] bg-white border border-secondary shadow-lg rounded-lg py-[4px]">
      <li
        className="flex items-center p-1 text-gray-800 hover:bg-gray-100 cursor-pointer"
        onClick={onProfileClick}
      >
        <FaUser className="mr-2" />
        <span>My Profile</span>
      </li>
      {role=="user" &&
      <li
        className="flex items-center p-1 text-gray-800 hover:bg-gray-100 cursor-pointer"
        onClick={()=>navigate("/password-change")}
      >
        <FaLock className="mr-2" />
        <span>Change Password</span>
      </li>}
      <li
        className="flex items-center p-1 hover:bg-gray-100 cursor-pointer text-red-500"
        onClick={onLogout}
      >
        <FaSignOutAlt className="mr-2" />
        <span>Log out</span>
      </li>
    </ul>
  );
};

const Header = ({email, name, role, }) => {
  const { currency } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const profileDropdownRef = useRef(null);
  const accessToken = JSON.parse(localStorage.getItem('access_token'));
  const toast = useRef(null);

  const dispatch = useDispatch();
  const toggleProfileDropdown = () => setProfileDropdownOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    dispatch(clearUser());
    navigate("/signin");
  };

  const handleProfileClick = () => {
    setIsModalOpen(true);
    setProfileDropdownOpen(false);
  };

  const handleProfileSave = (updatedProfile) => {
    updateUserProfile(updatedProfile);
  };
  
  const updateUserProfile = async (updatedProfile) => {
    setLoading(true);
    try {
      const { name, currency } = updatedProfile;
      const response = await userProfileUpdate(name, currency, accessToken);
  
      if (response.data.status === true) {
        await dispatch(fetchUserRole(accessToken)).unwrap();
        toast.current.show({ className: 'bg-green-300 text-white', severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.current.show({ className: 'bg-yellow-700 text-white', severity: 'warn', summary: 'Warning', detail: error.message, life: 3000 });
    } finally {
      setLoading(false);
    }
  };
  

  const profileFields = [
    { name: "name", label: "Name", value: name , disable: 'false'},
    { name: "email", label: "Email", value: email, type: "email", disable: 'true' },
    {
      name: "currency",
      label: "Default Currency",
      value: currency ? currency : 'CHF',
      type: "select",
      options: currencyOption
    },
  ];
  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
    <Toast ref={toast} />
    <header className="flex items-center justify-between fixed w-full z-50 p-4 shadow bg-primary text-white h-[4.5rem] border-b border-[rgba(255,255,255,.67)]">
      <div className="flex items-center space-x-4">
      <Link to={"/"}> <img src={logo} alt="App Icon" className="w-[4.5rem]" /></Link>
      </div>

      <div className="flex items-center">
        {role === "admin" && (
          <Link to={"/user-management"}>
            <button className="flex items-center p-1 rounded text-primary text-sm hover:bg-gray-100 cursor-pointer bg-secondary hover:bg-blue-700">
              <FaUser className="mr-2" />
              <span>User Management</span>
            </button>
          </Link>
        )}

        <div className="relative">
          <button
            type="button"
            className="py-3 px-4 inline-flex items-center gap-x-4 text-sm font-medium rounded-lg text-white shadow-sm"
          >
            <div className="flex flex-col items-start">
              <span className="text-base">{name ? name : ""}</span>
              <span className="text-xs text-[rgba(255,255,255,.67)] truncate w-24">
                {email ? email : ""}
                
              </span>
            </div>
          </button>
        </div>
        <div className="relative" ref={profileDropdownRef}>
          <img
            onClick={toggleProfileDropdown}
            src="https://images.unsplash.com/photo-1633332755192-727a05c4013d"
            alt="Profile"
            className={`h-10 w-10 cursor-pointer rounded-full object-cover border ${
              profileDropdownOpen ? "border-secondary" : ""
            }`}
          />
          <ProfileDropdownMenu
            isOpen={profileDropdownOpen}
            onProfileClick={handleProfileClick}
            onLogout={handleLogout}
            role={role}
            navigate={navigate}
          />
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fields={profileFields}
        onSave={handleProfileSave}
      />

    </header>
    </>
  );
};

export default Header;
